import { Config } from 'lib/types/configType';
import { getConfig } from 'lib/utils/getConfig';

export enum FlowStage {
  LANDING_PAGE = 'landingPage',
  EXISTING_USER = 'existingUser',
  NEW_USER = 'newUser',
  FORGOT_PASSWORD = 'forgotPassword',
  CREATE_PASSWORD = 'createPassword',
  SUCCESS = 'success',
  LINK = 'link',
}

export type AppState = {
  isLoading: boolean;
  isSocialAuth: {
    data: AnyObject;
    value: boolean;
    kind: string;
  };
  brand: string;
  account: Account | undefined;
  config: Config;
  codeInfo: {
    code?: string | undefined;
  };
  qrCode: string;
  error: unknown;
  flowStage: string;
  languageStrings: AnyObject;
  isRegister: {
    value: boolean | undefined;
    account: AnyObject;
  };
};

export type Account = {
  accessToken?: string;
  brand?: string;
  device?: string;
  email?: string;
  isNew?: boolean;
  refreshToken?: string;
  tokenExpiration?: number | string;
};

export const initialState: AppState = {
  isLoading: false,
  isSocialAuth: {
    data: {},
    value: false,
    kind: '',
  },
  brand: process.env.NEXT_PUBLIC_BRAND as string,
  account: {
    accessToken: '',
    isNew: undefined,
    refreshToken: '',
    tokenExpiration: '',
  },
  config: getConfig(),
  codeInfo: {},
  qrCode: '',
  error: '',
  flowStage: '',
  languageStrings: {},
  isRegister: {
    value: undefined,
    account: {},
  },
};
